import { gql } from '@apollo/client';

export const categoryFragment = gql`
    fragment CategoryFields on Category {
        id
        icon
        iconColor
        progressColor
        name
        description
        parentId
        templateId
        system
        customIcon
        questProgressTotal
        questProgressCompleted
        achievementProgressTotal
        achievementProgressCompleted
    }
`;
